import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { IhmErrorComponent } from './ihm-error.component';
import { IhmErrorRoutingModule } from './ihm-error.routing.module';

@NgModule({
  imports: [CommonModule, IhmErrorRoutingModule, MatCardModule, MatButtonModule],
  declarations: [IhmErrorComponent],
  exports: [IhmErrorComponent]
})
export class IhmErrorModule {}
